export const DOMAINS_REDUCER_NAME = 'domains'

export const DOMAINS_CACHE_REDUCER_NAME = 'domainsCache'
export const DOMAIN_DEALERS_REDUCER_NAME = 'domainDealers'
export const DOMAIN_EXPORT_REDUCER_NAME = 'domainExport'
export const MIST_ORGANIZATION_REDUCER_NAME = 'mistOrganization'
export const DOMAIN_TO_SUB_DOMAINS_CACHE_REDUCER_NAME = 'domainIdToSubDomains'
export const DOMAIN_TO_DOMAIN_DATA_CACHE_REDUCER_NAME = 'domainIdToDomain'

export const DOMAIN_JOBS_WITH_HOME_REDUCER_NAME = 'domainJobsWithHome'
export const DOMAIN_JOBS_WITH_HOME_COUNT_REDUCER_NAME =
  'domainJobsWithHomeCount'
export const DOMAIN_PENDING_JOBS_REDUCER_NAME = 'domainPendingJobs'

export const SELECTED_NAV_DOMAIN_REDUCER_NAME = 'selectedNavDomain'
export const SELECTED_NAV_TOP_DOMAIN_REDUCER_NAME = 'selectedNavTopDomain'

export const DOMAINS_QUERY_PARAM_SHORTCUT = 'd'
